import request from '@/utils/request'
import base from '@/api/base'

const recycleBinApi = {
  getProjRecycleList: base.api + '/motion/client/recycle/getProjRecycleList', // 回收站项目列表
  resetProject: base.api + '/motion/client/recycle/resetProject', // 恢复回收站项目
  deleteRecycleProject: base.api + '/motion/client/recycle/deleteRecycleProject', // 彻底删除回收站项目
  queryRecycleBinPage: base.api + '/family/mall/new/biCube/queryRecycleBinPage', // 回收站沙盘列表
  emptyRecycleBin: base.api + '/family/mall/new/biCube/emptyRecycleBin', // 回收站沙盘全部清空
  restore: base.api + '/family/mall/new/biCube/restore', // 回收站沙盘恢复
  completelyCancel: base.api + '/family/mall/new/biCube/completelyCancel'
}
// 回收站项目列表
export function getProjRecycleList(data) {
return request({
    url: recycleBinApi.getProjRecycleList,
    method: 'POST',
    data
})
}

// 恢复回收站项目
export function resetProject(data) {
  return request({
    url: recycleBinApi.resetProject,
    method: 'POST',
    data
  })
}

// 回收站项目删除
export function deleteRecycleProject(data) {
  return request({
    url: recycleBinApi.deleteRecycleProject,
    method: 'POST',
    data
  })
}

// 回收站沙盘列表
export function queryRecycleBinPage(data) {
  return request({
    url: recycleBinApi.queryRecycleBinPage,
    method: 'POST',
    data
  })
}

// 回收站全部清空
export function emptyRecycleBin(data) {
  return request({
    url: recycleBinApi.emptyRecycleBin,
    method: 'POST',
    data
  })
}

// 回收站沙盘恢复
export function restore(data) {
  return request({
    url: recycleBinApi.restore,
    method: 'POST',
    data
  })
}

// 回收站沙盘彻底删除
export function completelyCancel(data) {
  return request({
    url: recycleBinApi.completelyCancel,
    method: 'POST',
    data
  })
}